<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="subtitle-1 text-center pa-5">{{ text }}</v-card-text>
      <v-card-actions class="d-flex flex-column align-stretch pa-4">
        <v-btn
          :color="confirmButtonColor"
          block
          class="mb-2 mx-0"
          @click="onConfirm"
        >{{ confirmButtonText }}</v-btn>
        <v-btn
          v-if="showCancelButton"
          text
          outlined
          color="warning"
          block
          class="mx-0"
          @click="onCancel"
        >{{ cancelButtonText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'ConfirmDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: 'Atenção'
    },
    text: {
      type: String,
      default: 'Confirmar a ação?'
    },
    cancelButtonText: {
      type: String,
      default: 'Cancelar'
    },
    confirmButtonText: {
      type: String,
      default: 'Confirmar'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    confirmButtonColor: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      dialog: true
    }
  },
  methods: {
    onConfirm() {
      this.$emit('on-confirm')
      this.closeDialog()
    },
    onCancel() {
      this.$emit('on-cancel')
      this.closeDialog()
    },
    closeDialog() {
      this.$emit('input', false)
    }
  }
})
</script>

<style scoped>
.title {
  font-weight: 600;
  color: #fff;
  font-size: 1rem !important;
}
.icon-calendar {
  display: flex;
  justify-content: flex-end;
  height: 100%;
  margin-right: 10px;
}
.button-icon {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-content: center;
  border-radius: 50%;
}
.button-active {
  background-color: #006bf2;
  transform: scale(1.1);
  cursor: pointer;
}
</style>
